import { RouterProvider, createBrowserRouter } from 'react-router-dom'
import HomePage from './pages/Home'
import MessageSenderPage from './pages/MessageSender'
import MessageSchedulerPage from './pages/MessageScheduler'
import SettingsPage from './pages/Settings'
import SigninPage from './pages/Signin'
import ReportsPage from './pages/Reports'
import DocumentationPage from './pages/Documentation'
import ChangelogPage from './pages/Changelog'
import PaymentProfilesPage from './pages/PaymentProfiles'
import SmartFilterPage from './pages/SmartFilter'

const router = createBrowserRouter([
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/messages/send',
    element: <MessageSenderPage />
  },
  {
    path: '/messages/scheduler',
    element: <MessageSchedulerPage />
  },
  {
    path: '/reports',
    element: <ReportsPage />
  },
  {
    path: '/settings',
    element: <SettingsPage />
  },
  {
    path: '/documentation',
    element: <DocumentationPage />
  },
  {
    path: '/signin',
    element: <SigninPage />
  },
  {
    path: '/changelog',
    element: <ChangelogPage />
  },
  {
    path: '/hiperpay/profiles',
    element: <PaymentProfilesPage />
  },
  {
    path: '/smart-filter',
    element: <SmartFilterPage />
  }
])

export default function Routes() {
  return <RouterProvider router={router} />
}
